import { render } from "./ReportInventoriesIndex.vue?vue&type=template&id=d717122a&scoped=true"
import script from "./ReportInventoriesIndex.vue?vue&type=script&lang=js"
export * from "./ReportInventoriesIndex.vue?vue&type=script&lang=js"

import "./ReportInventoriesIndex.vue?vue&type=style&index=0&id=d717122a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d717122a"]])

export default __exports__